<template>
  <div class="employee-management store-attendance">
    <div class="lvyun-profile-banner">
      <h2>门店考勤与薪资</h2>
      <p>按人维护底薪、本月应出勤、加班天数/加班小时（二选一）；系统按“加班日薪/加班时薪”计算加班薪资，并自动计算请假扣款与总工资。</p>
    </div>
    <el-card class="employee-card" shadow="never">
      <template slot="header">
        <div class="card-header card-header--wrap">
          <div class="card-title">门店考勤</div>
          <div class="toolbar-actions">
            <el-date-picker
              v-model="filterMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择月份"
              size="small"
              class="filter-month"
              @change="onMonthChange"
            />
            <el-select
              v-model="filterEmployeeName"
              placeholder="输入姓名查找员工"
              clearable
              filterable
              reserve-keyword
              default-first-option
              size="small"
              class="filter-employee"
            >
              <el-option label="全部员工" value="" />
              <el-option
                v-for="n in employeeNameOptions"
                :key="n"
                :label="n"
                :value="n"
              />
            </el-select>
            <el-button
              type="primary"
              icon="el-icon-plus"
              class="btn-primary"
              size="small"
              @click="openAdd"
            >
              新增考勤
            </el-button>
            <el-button class="btn-secondary" size="small" @click="downloadTemplate">下载模板</el-button>
            <el-upload
              action="#"
              :show-file-list="false"
              accept=".xlsx,.xls"
              :http-request="doImport"
            >
              <el-button class="btn-secondary" size="small">导入 Excel</el-button>
            </el-upload>
            <el-button class="btn-secondary" size="small" @click="downloadExport">导出报表</el-button>
          </div>
        </div>
      </template>

      <el-table :data="displayRows" style="width: 100%" stripe class="employee-table">
        <el-table-column prop="employee_name" label="员工姓名" width="100" />
        <el-table-column prop="phone" label="联系电话" width="120" />
        <el-table-column prop="position" label="岗位" width="100" show-overflow-tooltip />
        <el-table-column label="底薪" width="100" align="right">
          <template slot-scope="scope">{{ fmtMoney(scope.row.base_salary) }}</template>
        </el-table-column>
        <el-table-column prop="required_days" label="本月应出勤(天)" width="110" align="center" />
        <el-table-column prop="actual_days" label="实际出勤(天)" width="110" align="center" />
        <el-table-column prop="leave_days" label="请假(天)" width="88" align="center" />
        <el-table-column prop="overtime_days" label="加班(天)" width="88" align="center" />
        <el-table-column prop="overtime_hours" label="加班(小时)" width="100" align="center" />
        <el-table-column label="天单价" width="88" align="right" show-overflow-tooltip>
          <template slot-scope="scope">{{ fmtMoney(scope.row.effective_overtime_day_wage) }}</template>
        </el-table-column>
        <el-table-column label="时单价" width="88" align="right" show-overflow-tooltip>
          <template slot-scope="scope">{{ fmtMoney(scope.row.effective_overtime_hour_wage) }}</template>
        </el-table-column>
        <el-table-column label="出勤日薪" width="96" align="right">
          <template slot-scope="scope">{{ fmtMoney(scope.row.attendance_daily_wage) }}</template>
        </el-table-column>
        <el-table-column label="请假扣款" width="100" align="right">
          <template slot-scope="scope">{{ fmtMoney(scope.row.leave_deduction) }}</template>
        </el-table-column>
        <el-table-column label="加班薪资" width="100" align="right">
          <template slot-scope="scope">{{ fmtMoney(scope.row.overtime_pay) }}</template>
        </el-table-column>
        <el-table-column label="总工资" width="100" align="right">
          <template slot-scope="scope">
            <span class="total-salary">{{ fmtMoney(scope.row.total_salary) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" class="btn-secondary" @click="openEdit(scope.row)">编辑</el-button>
            <el-button
              v-if="canAdminDeleteSession"
              size="small"
              class="btn-secondary danger"
              @click="removeRow(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="580px" @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="152px" size="small">
        <el-form-item label="考勤月份" prop="attendance_month">
          <el-date-picker
            v-model="form.attendance_month"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="员工" prop="linked_employee_id">
          <el-select
            v-model="form.linked_employee_id"
            filterable
            reserve-keyword
            default-first-option
            placeholder="输入姓名/手机号查找员工"
            style="width: 100%;"
            @change="onAttendanceEmployeeChange"
          >
            <el-option
              v-for="e in employeeDirectory"
              :key="e.id"
              :label="employeeOptionLabel(e)"
              :value="String(e.id)"
            />
          </el-select>
          <div class="form-field-hint">姓名与手机号与「员工管理」一致，保存时自动带出</div>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" placeholder="选择员工后自动填充" maxlength="11" readonly class="readonly-calc-input" />
        </el-form-item>
        <el-form-item label="岗位" prop="position">
          <el-input v-model="form.position" placeholder="岗位" />
        </el-form-item>
        <el-form-item label="底薪(元)" prop="base_salary">
          <el-input-number
            v-model="form.base_salary"
            :min="0"
            :precision="2"
            :step="100"
            style="width: 100%;"
            @change="onBaseSalaryChange"
          />
        </el-form-item>
        <el-form-item label="日薪(元/天)">
          <el-input-number
            v-model="form.salary_daily_wage"
            :min="0"
            :precision="2"
            :step="1"
            style="width: 100%;"
            @change="onDailyWageChange"
          />
        </el-form-item>
        <el-form-item label="时薪(元/小时)">
          <el-input-number
            v-model="form.salary_hourly_wage"
            :min="0"
            :precision="2"
            :step="0.5"
            style="width: 100%;"
            @change="onHourlyWageChange"
          />
          <div class="form-field-hint">时薪 = 日薪 / 8（双向自动换算）</div>
        </el-form-item>
        <el-form-item label="本月应出勤天数" prop="required_days">
          <el-input-number
            v-model="form.required_days"
            :min="0"
            :max="31"
            :precision="1"
            :step="1"
            style="width: 100%;"
            @change="onRequiredDaysChange"
          />
        </el-form-item>
        <el-form-item label="实际出勤天数" prop="actual_days">
          <el-input-number
            v-model="form.actual_days"
            :min="0"
            :max="31"
            :precision="1"
            :step="1"
            style="width: 100%;"
            @change="onActualDaysChange"
          />
        </el-form-item>
        <el-form-item label="请假天数" prop="leave_days">
          <el-input-number
            v-model="form.leave_days"
            :min="0"
            :max="31"
            :precision="1"
            :step="0.5"
            style="width: 100%;"
            @change="onLeaveDaysChange"
          />
        </el-form-item>
        <el-form-item label="加班天数" prop="overtime_days">
          <el-input-number
            v-model="form.overtime_days"
            :min="0"
            :max="31"
            :precision="1"
            :step="0.5"
            style="width: 100%;"
            @change="onOvertimeDaysChange"
          />
        </el-form-item>
        <el-form-item label="加班时长(小时)" prop="overtime_hours">
          <el-input-number
            v-model="form.overtime_hours"
            :min="0"
            :precision="1"
            :step="0.5"
            style="width: 100%;"
            @change="onOvertimeHoursChange"
          />
        </el-form-item>
        <el-form-item prop="custom_overtime_day_wage">
          <span slot="label">加班日薪</span>
          <el-input-number
            v-model="form.custom_overtime_day_wage"
            :min="0"
            :precision="2"
            :step="10"
            style="width: 100%;"
          />
          <div class="form-field-hint">元/天，仅按该值计算加班天薪资</div>
        </el-form-item>
        <el-form-item prop="custom_overtime_hour_wage">
          <span slot="label">加班时薪</span>
          <el-input-number
            v-model="form.custom_overtime_hour_wage"
            :min="0"
            :precision="2"
            :step="5"
            style="width: 100%;"
          />
          <div class="form-field-hint">元/小时，仅按该值计算加班小时薪资</div>
        </el-form-item>
        <el-form-item label="出勤日薪">
          <el-input :value="fmtMoney(preview.attendance_daily_wage)" readonly class="readonly-calc-input" />
        </el-form-item>
        <el-form-item label="请假扣款">
          <el-input :value="fmtMoney(preview.leave_deduction)" readonly class="readonly-calc-input" />
        </el-form-item>
        <el-form-item label="加班薪资">
          <el-input :value="fmtMoney(preview.overtime_pay)" readonly class="readonly-calc-input" />
        </el-form-item>
        <el-form-item label="五险扣除(元)" prop="social_insurance_deduction">
          <el-input-number
            v-model="form.social_insurance_deduction"
            :min="0"
            :precision="2"
            :step="10"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="总工资">
          <el-input :value="fmtMoney(preview.total_salary)" readonly class="readonly-calc-input preview-total-input" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { apiBase } from '../api/client'
import { getAdminToken, canAdminDelete } from '../utils/auth'
import { formatApiError } from '../utils/apiError'

function currentMonth() {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}

function round4(x) {
  return Math.round((Number(x) || 0) * 10000) / 10000
}

function round2(x) {
  return Math.round((Number(x) || 0) * 100) / 100
}

function normalizeOvertimeMode(r) {
  const d = Number(r.overtime_days) || 0
  const h = Number(r.overtime_hours) || 0
  if (d > 0) return { overtime_days: d, overtime_hours: 0, overtime_mode: 'day' }
  if (h > 0) return { overtime_days: 0, overtime_hours: h, overtime_mode: 'hour' }
  return { overtime_days: 0, overtime_hours: 0, overtime_mode: 'none' }
}

function normalizeLeaveMode(r) {
  const leaveDays = round4(Number(r.leave_days) || 0)
  const leaveHours = round4(Number(r.leave_hours) || 0)
  if (leaveDays > 0) return { leave_days: leaveDays, leave_hours: 0, leave_mode: 'day', leave_days_equiv: leaveDays }
  if (leaveHours > 0) {
    return {
      leave_days: 0,
      leave_hours: leaveHours,
      leave_mode: 'hour',
      leave_days_equiv: round4(leaveHours / 8)
    }
  }
  return { leave_days: 0, leave_hours: 0, leave_mode: 'none', leave_days_equiv: 0 }
}

function calcDerived(r) {
  const mode = normalizeOvertimeMode(r || {})
  const leave = normalizeLeaveMode(r || {})
  const base = round4(Number(r.base_salary) || 0)
  const req = round4(Number(r.required_days) || 0)
  const otDays = round4(mode.overtime_days)
  const ot = round4(mode.overtime_hours)
  const daily = req > 0 ? round4(base / req) : 0
  const hourly = round4(daily / 8)
  const leaveDeduction =
    leave.leave_mode === 'hour' ? round4(leave.leave_hours * hourly) : round4(leave.leave_days * daily)
  const rawActual = Number(r.actual_days)
  const hasActualInput = Number.isFinite(rawActual) && rawActual > 0
  const actualDays = round4(
    hasActualInput ? rawActual : Math.max(0, req - leave.leave_days_equiv)
  )
  const customDay = Number(r.custom_overtime_day_wage) || 0
  const customHour = Number(r.custom_overtime_hour_wage) || 0
  const dayUnit = round4(customDay > 0 ? customDay : 0)
  const hourUnit = round4(customHour > 0 ? customHour : 0)
  const overtimePay = mode.overtime_mode === 'day' ? round4(otDays * dayUnit) : round4(ot * hourUnit)
  const socialInsuranceDeduction = round4(Number(r.social_insurance_deduction) || 0)
  // 新口径：总工资 = 实际出勤天数 × 日薪 - 请假扣款 - 五险扣除（加班薪资单独展示）
  const payableSalary = round4(actualDays * daily)
  const totalSalary = round4(payableSalary - leaveDeduction - socialInsuranceDeduction)
  return {
    daily_wage: round2(daily),
    attendance_daily_wage: round2(daily),
    hourly_wage: round2(hourly),
    actual_days: round2(actualDays),
    leave_mode: leave.leave_mode,
    leave_days: leave.leave_days,
    leave_hours: leave.leave_hours,
    payable_salary: round2(payableSalary),
    effective_overtime_day_wage: round2(dayUnit),
    effective_overtime_hour_wage: round2(hourUnit),
    overtime_mode: mode.overtime_mode,
    overtime_days: otDays,
    overtime_hours: ot,
    leave_deduction: round2(leaveDeduction),
    overtime_pay: round2(overtimePay),
    social_insurance_deduction: round2(socialInsuranceDeduction),
    total_salary: round2(totalSalary)
  }
}

export default {
  name: 'StoreAttendance',
  data() {
    return {
      filterMonth: currentMonth(),
      filterEmployeeName: '',
      rows: [],
      employeeNameOptions: [],
      employeeDirectory: [],
      dialogVisible: false,
      dialogTitle: '新增考勤',
      isEdit: false,
      saving: false,
      addDraft: null,
      form: {
        id: null,
        attendance_month: currentMonth(),
        linked_employee_id: '',
        employee_name: '',
        phone: '',
        position: '',
        base_salary: 0,
        salary_daily_wage: 0,
        salary_hourly_wage: 0,
        required_days: 0,
        actual_days: 0,
        leave_days: 0,
        overtime_days: 0,
        overtime_hours: 0,
        custom_overtime_day_wage: 0,
        custom_overtime_hour_wage: 0,
        social_insurance_deduction: 0
      },
      rules: {
        attendance_month: [{ required: true, message: '请选择月份', trigger: 'change' }],
        linked_employee_id: [{ required: true, message: '请选择员工', trigger: 'change' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        base_salary: [{ required: true, message: '请输入底薪', trigger: 'change' }],
        required_days: [{ required: true, message: '请输入本月应出勤天数', trigger: 'change' }]
      }
    }
  },
  computed: {
    canAdminDeleteSession() {
      return canAdminDelete()
    },
    displayRows() {
      const list = (this.rows || []).map((r) => ({ ...r, ...calcDerived(r) }))
      const name = (this.filterEmployeeName || '').trim()
      if (!name) return list
      return list.filter((r) => String(r.employee_name || '').trim() === name)
    },
    preview() {
      return calcDerived(this.form)
    }
  },
  watch: {
    filterMonth() {
      this.loadEmployeeNames()
    }
  },
  async mounted() {
    await this.loadEmployeeDirectory()
    await this.loadList()
    await this.loadEmployeeNames()
  },
  methods: {
    employeeOptionLabel(e) {
      if (!e) return ''
      const n = String(e.name || '').trim() || '未命名'
      const p = String(e.phone || '').trim()
      return p ? `${n}（${p}）` : n
    },
    onAttendanceEmployeeChange(empId) {
      const idStr = String(empId || '').trim()
      const e = (this.employeeDirectory || []).find((x) => String(x.id) === idStr)
      if (!e) {
        this.form.employee_name = ''
        this.form.phone = ''
        return
      }
      this.form.employee_name = String(e.name || '').trim()
      this.form.phone = String(e.phone || '').replace(/\D/g, '').slice(0, 11)
    },
    async loadEmployeeDirectory() {
      try {
        const resp = await this.$api.get('/admin/employees')
        if (resp && resp.code === 200 && Array.isArray(resp.data)) {
          this.employeeDirectory = resp.data.map((row) => ({
            id: row._id != null ? row._id : row.id,
            name: row.name || '',
            phone: row.phone || ''
          }))
        } else {
          this.employeeDirectory = []
        }
      } catch (_e) {
        this.employeeDirectory = []
      }
    },
    fmtMoney(v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return '—'
      return n.toFixed(2)
    },
    authHeaders() {
      const t = getAdminToken()
      return t ? { Authorization: `Bearer ${t}` } : {}
    },
    clampNonNeg(v) {
      const n = Number(v)
      if (!Number.isFinite(n) || n < 0) return 0
      return n
    },
    calcActualDays(reqDays, leaveDays, leaveHours) {
      const req = this.clampNonNeg(reqDays)
      const leaveD = this.clampNonNeg(leaveDays)
      const leaveH = this.clampNonNeg(leaveHours)
      const leaveEquiv = leaveD > 0 ? leaveD : leaveH > 0 ? round4(leaveH / 8) : 0
      return round4(Math.max(0, req - leaveEquiv))
    },
    syncWagesFromBase() {
      const req = this.clampNonNeg(this.form.required_days)
      const base = this.clampNonNeg(this.form.base_salary)
      const daily = req > 0 ? round2(base / req) : 0
      const hourly = round2(daily / 8)
      this.form.salary_daily_wage = daily
      this.form.salary_hourly_wage = hourly
    },
    onBaseSalaryChange() {
      this.form.base_salary = this.clampNonNeg(this.form.base_salary)
      this.syncWagesFromBase()
    },
    onDailyWageChange() {
      const daily = this.clampNonNeg(this.form.salary_daily_wage)
      const hourly = round2(daily / 8)
      const req = this.clampNonNeg(this.form.required_days)
      this.form.salary_daily_wage = daily
      this.form.salary_hourly_wage = hourly
      this.form.base_salary = round2(daily * req)
    },
    onHourlyWageChange() {
      const hourly = this.clampNonNeg(this.form.salary_hourly_wage)
      const daily = round2(hourly * 8)
      const req = this.clampNonNeg(this.form.required_days)
      this.form.salary_hourly_wage = hourly
      this.form.salary_daily_wage = daily
      this.form.base_salary = round2(daily * req)
    },
    normalizeFormForSubmit() {
      const d = normalizeOvertimeMode(this.form || {})
      const actualInput = this.clampNonNeg(this.form.actual_days)
      const actualAuto = this.calcActualDays(this.form.required_days, this.form.leave_days, this.form.leave_hours)
      const body = {
        attendance_month: this.form.attendance_month,
        employee_name: this.form.employee_name,
        phone: this.form.phone,
        position: this.form.position,
        base_salary: this.clampNonNeg(this.form.base_salary),
        required_days: this.clampNonNeg(this.form.required_days),
        actual_days: actualInput > 0 ? actualInput : actualAuto,
        leave_days: this.clampNonNeg(this.form.leave_days),
        overtime_days: this.clampNonNeg(d.overtime_days),
        overtime_hours: this.clampNonNeg(d.overtime_hours),
        custom_overtime_day_wage: this.clampNonNeg(this.form.custom_overtime_day_wage),
        custom_overtime_hour_wage: this.clampNonNeg(this.form.custom_overtime_hour_wage)
      }
      return body
    },
    validateBusinessRules(payload) {
      const req = Number(payload.required_days) || 0
      const leave = Number(payload.leave_days) || 0
      const actual = Number(payload.actual_days) || 0
      if (req <= 0 && (leave > 0 || actual > 0)) {
        this.$message.error('应出勤天数为 0 时，请假天数和实际出勤天数必须为 0')
        return false
      }
      return true
    },
    onRequiredDaysChange() {
      const req = this.clampNonNeg(this.form.required_days)
      this.form.required_days = req
      this.syncWagesFromBase()
    },
    onActualDaysChange() {
      this.form.actual_days = this.clampNonNeg(this.form.actual_days)
    },
    onLeaveDaysChange() {
      this.form.leave_days = this.clampNonNeg(this.form.leave_days)
    },
    onOvertimeDaysChange() {
      this.form.overtime_days = this.clampNonNeg(this.form.overtime_days)
      if ((Number(this.form.overtime_days) || 0) > 0) {
        this.form.overtime_hours = 0
      }
    },
    onOvertimeHoursChange() {
      this.form.overtime_hours = this.clampNonNeg(this.form.overtime_hours)
      if ((Number(this.form.overtime_hours) || 0) > 0) {
        this.form.overtime_days = 0
      }
    },
    async loadList() {
      try {
        const month = this.filterMonth || currentMonth()
        const resp = await this.$api.get('/admin/store-attendance', { params: { month } })
        if (resp && resp.code === 200) {
          this.rows = Array.isArray(resp.data) ? resp.data : []
        } else {
          this.rows = []
        }
      } catch (e) {
        this.rows = []
        this.$message.error(formatApiError(e, '加载考勤失败'))
      }
    },
    async loadEmployeeNames() {
      try {
        const month = this.filterMonth || currentMonth()
        const resp = await this.$api.get('/admin/store-attendance/employee-names', { params: { month } })
        const fromApi =
          resp && resp.code === 200 && Array.isArray(resp.data) ? resp.data.map((x) => String(x).trim()) : []
        const fromDir = (this.employeeDirectory || []).map((e) => String(e.name || '').trim()).filter(Boolean)
        this.employeeNameOptions = [...new Set([...fromDir, ...fromApi])].sort()
      } catch (_e) {
        const fromDir = (this.employeeDirectory || []).map((e) => String(e.name || '').trim()).filter(Boolean)
        this.employeeNameOptions = [...new Set(fromDir)].sort()
      }
    },
    onMonthChange() {
      this.filterEmployeeName = ''
      this.loadList()
      this.loadEmployeeNames()
    },
    async openAdd() {
      if (!(this.employeeDirectory && this.employeeDirectory.length)) {
        await this.loadEmployeeDirectory()
      }
      this.dialogTitle = '新增考勤'
      this.isEdit = false
      if (this.addDraft && typeof this.addDraft === 'object') {
        this.form = { ...this.addDraft }
      } else {
        this.form = {
          id: null,
          attendance_month: this.filterMonth || currentMonth(),
          linked_employee_id: '',
          employee_name: '',
          phone: '',
          position: '',
          base_salary: 0,
          salary_daily_wage: 0,
          salary_hourly_wage: 0,
          required_days: 0,
          actual_days: 0,
          leave_days: 0,
          overtime_days: 0,
          overtime_hours: 0,
          custom_overtime_day_wage: 0,
          custom_overtime_hour_wage: 0,
          social_insurance_deduction: 0
        }
      }
      this.onRequiredDaysChange()
      this.syncWagesFromBase()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    async openEdit(row) {
      if (!(this.employeeDirectory && this.employeeDirectory.length)) {
        await this.loadEmployeeDirectory()
      }
      this.dialogTitle = '编辑考勤'
      this.isEdit = true
      const nameT = String(row.employee_name || '').trim()
      const phoneT = String(row.phone || '').replace(/\D/g, '')
      const match = (this.employeeDirectory || []).find(
        (e) =>
          String(e.name || '').trim() === nameT &&
          String(String(e.phone || '').replace(/\D/g, '')) === phoneT
      )
      this.form = {
        id: row.id,
        attendance_month: row.attendance_month,
        linked_employee_id: match ? String(match.id) : '',
        employee_name: row.employee_name,
        phone: row.phone,
        position: row.position || '',
        base_salary: Number(row.base_salary) || 0,
        salary_daily_wage: 0,
        salary_hourly_wage: 0,
        required_days: Number(row.required_days) || 0,
        actual_days: Number(row.actual_days) || 0,
        leave_days: Number(row.leave_days) || 0,
        overtime_days: Number(row.overtime_days) || 0,
        overtime_hours: Number(row.overtime_hours) || 0,
        custom_overtime_day_wage: Number(row.custom_overtime_day_wage) || 0,
        custom_overtime_hour_wage: Number(row.custom_overtime_hour_wage) || 0,
        social_insurance_deduction: Number(row.social_insurance_deduction) || 0
      }
      this.onRequiredDaysChange()
      this.syncWagesFromBase()
      this.onOvertimeDaysChange()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    resetForm() {
      if (!this.isEdit) {
        this.addDraft = { ...this.form }
      }
      this.saving = false
    },
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.saving = true
        try {
          const body = this.normalizeFormForSubmit()
          if (!this.validateBusinessRules(body)) return
          let resp
          if (this.isEdit) {
            resp = await this.$api.put(`/admin/store-attendance/${this.form.id}`, body)
          } else {
            resp = await this.$api.post('/admin/store-attendance', body)
          }
          if (resp && (resp.code === 200 || resp.code === 201)) {
            this.addDraft = null
            this.$message.success(resp.message || '保存成功')
            this.dialogVisible = false
            await this.loadList()
            await this.loadEmployeeNames()
          } else {
            this.$message.error((resp && resp.message) || '保存失败')
          }
        } catch (e) {
          this.$message.error(formatApiError(e, '保存失败'))
        } finally {
          this.saving = false
        }
      })
    },
    removeRow(row) {
      this.$confirm(`确定删除「${row.employee_name}」${row.attendance_month} 的考勤记录？`, '提示', {
        type: 'warning'
      })
        .then(async () => {
          try {
            const resp = await this.$api.delete(`/admin/store-attendance/${row.id}`)
            if (resp && resp.code === 200) {
              this.$message.success('已删除')
              await this.loadList()
              await this.loadEmployeeNames()
            } else {
              this.$message.error((resp && resp.message) || '删除失败')
            }
          } catch (e) {
            this.$message.error(formatApiError(e, '删除失败'))
          }
        })
        .catch(() => {})
    },
    async downloadTemplate() {
      try {
        const res = await axios.get(`${apiBase}/admin/store-attendance/template`, {
          responseType: 'blob',
          headers: this.authHeaders()
        })
        this.saveBlob(res.data, '门店考勤导入模板.xlsx')
      } catch (e) {
        this.$message.error(formatApiError(e, '下载失败'))
      }
    },
    async downloadExport() {
      try {
        const month = this.filterMonth || currentMonth()
        const res = await axios.get(`${apiBase}/admin/store-attendance/export`, {
          params: { month },
          responseType: 'blob',
          headers: this.authHeaders()
        })
        this.saveBlob(res.data, `门店考勤_${month}.xlsx`)
      } catch (e) {
        this.$message.error(formatApiError(e, '导出失败'))
      }
    },
    saveBlob(blob, filename) {
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
    async doImport(req) {
      const file = req.file
      if (!file) return
      const fd = new FormData()
      fd.append('file', file)
      try {
        const res = await axios.post(`${apiBase}/admin/store-attendance/import`, fd, {
          headers: { ...this.authHeaders(), 'Content-Type': 'multipart/form-data' }
        })
        const data = res.data
        if (data && data.code === 200) {
          const d = data.data || {}
          let msg = data.message || '导入完成'
          if (d.fail > 0 && d.errors && d.errors.length) {
            msg += `；部分失败：${d.errors.slice(0, 3).join('；')}`
          }
          this.$message[d.fail > 0 ? 'warning' : 'success'](msg)
          await this.loadList()
          await this.loadEmployeeNames()
        } else {
          this.$message.error((data && data.message) || '导入失败')
        }
      } catch (e) {
        this.$message.error(formatApiError(e, '导入失败'))
      } finally {
        if (req.onSuccess) req.onSuccess()
      }
    }
  }
}
</script>

<style>
/* 与员工管理页一致的版式与表格样式 */
.employee-management {
  padding: 24px;
  background: #f5f7fa;
}

.employee-card {
  border-radius: 12px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.06);
  border: none;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
}

.btn-primary {
  background: #165dff;
  border-color: #165dff;
  border-radius: 8px;
  padding: 8px 16px;
  font-weight: 500;
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.btn-primary:hover {
  background: #1546d4;
  border-color: #1546d4;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(22, 93, 255, 0.35);
}

.btn-secondary {
  border-radius: 8px;
  background: #f3f4f6;
  border-color: #e5e6eb;
  color: #4e5969;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.btn-secondary:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

.btn-secondary.danger {
  color: #f53f3f;
  border-color: #ffd1cc;
  background: #fff2f0;
}

.employee-table ::v-deep(.el-table__header-wrapper th) {
  background: #f7f8fa;
  color: #1d2129;
  font-weight: 600;
  padding-top: 14px;
  padding-bottom: 14px;
}

.employee-table ::v-deep(.el-table__header-wrapper thead tr) {
  background: #f7f8fa;
}

.employee-table ::v-deep(.el-table__body-wrapper td) {
  padding-top: 16px;
  padding-bottom: 16px;
}

.employee-table ::v-deep(.el-table__body-wrapper tr:nth-child(2n)) {
  background: #fafafa;
}

.employee-table ::v-deep(.el-table__body-wrapper tr:hover > td) {
  background-color: #f2f3f5 !important;
  transition: background-color 0.2s ease;
}

.employee-table ::v-deep(.cell) {
  white-space: nowrap;
}

.store-attendance .card-header--wrap {
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-start;
}

.store-attendance .toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  flex: 1;
  min-width: 240px;
}

.store-attendance .filter-month {
  width: 140px;
}

.store-attendance .filter-employee {
  width: 160px;
}

.store-attendance .total-salary {
  font-weight: 600;
  color: #165dff;
}

.store-attendance .readonly-calc-input >>> .el-input__inner {
  background: #f7f8fa;
  color: #1d2129;
  cursor: default;
}

.store-attendance .preview-total-input >>> .el-input__inner {
  font-weight: 600;
  color: #165dff;
}

.store-attendance .form-field-hint {
  font-size: 12px;
  color: #86909c;
  line-height: 1.4;
  margin-top: 4px;
}
</style>
